import { Box, Grid, Skeleton } from "@mui/material";
import React from "react";

const TripViewSkeleton = () => {
  return (
    <>
      <Box
        sx={{
          height: "fit-content",
          padding: "0px",
          margin: "0px",
          overflow: "hidden",
        }}
      >
        <Grid container spacing={2} padding={3}>
        <Grid item xs={12}>
              <Skeleton variant="rectangular" sx={{ mt: 2}}/>
        </Grid>
        {[...Array(8)].map((_, index) => (
          <React.Fragment key={index}>
            <Grid item xs={12} sm={6}>
              <Skeleton key={index} variant="rectangular" />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Skeleton key={index} variant="rectangular" />
            </Grid>
          </React.Fragment>
        ))}
         <Grid item xs={12}>
              <Skeleton variant="rectangular"  />
        </Grid>
        <Grid item xs={12}>
              <Skeleton variant="rectangular"  />
        </Grid>
        <Grid item xs={12}>
              <Skeleton variant="rectangular" />
        </Grid>
        <Grid item xs={12}>
              <Skeleton variant="rectangular" height={200}  />
        </Grid>
        <Grid item xs={12}>
              <Skeleton variant="rectangular" />
        </Grid>
        <Grid item xs={12}>
              <Skeleton variant="rectangular" height={200}  />
        </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default TripViewSkeleton;
